import React from 'react';
import { Image } from 'react-native';

import { Box, Inline } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import useMount from '../../../hooks/useMount';
import analytics from '../../../modules/analytics';

import {
  BodyText,
  Button,
  Stack,
  Touchable,
} from '..';

import { CloseIcon } from '../Icons';

type CarouselCardProps = {
  title: string | React.ReactNode;
  body: string | React.ReactNode;
  icon?: React.ReactNode;
  backgroundColor?: string;
  cta: string;
  ctaProps?: Object;
  onDismiss?: () => void;
  viewEventName?: string;
  testID?: string;
};

export const CarouselCard: React.FC<CarouselCardProps> = ({
  title,
  body,
  icon,
  backgroundColor = colors.whiteWash,
  cta,
  ctaProps = {},
  onDismiss,
  viewEventName,
  testID,
}) => {
  useMount(() => {
    if (viewEventName) {
      analytics.track(viewEventName);
    }
  });

  return (
    <Box paddingX={4} paddingY={8}>
      <Box
        testID={testID}
        color={backgroundColor}
        paddingX={8}
        paddingY={4}
        borderRadius={4}
        justifyContent="center"
        style={{
          width: '168px',
          height: '168px',
          boxShadow: '0px 1px 4px rgba(18, 17, 17, 0.15)',
        }}
      >
        {onDismiss && (
          <Inline justifyContent="flex-end" paddingTop={6} paddingRight={2}>
            <Touchable
              onPress={onDismiss}
              testID={testID ? `${testID}-dismiss` : undefined}
            >
              <Box>
                <CloseIcon height={12} width={12} viewBox="0 0 20 20" />
              </Box>
            </Touchable>
          </Inline>
        )}
        {icon
          ? (
            <Stack alignItems="center">
              <Box paddingY={12}>
                <Image
                  source={icon}
                  resizeMode="contain"
                  style={{
                    width: 35,
                    height: 35,
                  }}
                />
              </Box>
            </Stack>
          )
          : <Box paddingTop={onDismiss ? 28 : 40} />}
        <Stack flexGrow={1}>
          <Box>
            <BodyText textAlign="center" weight="bold" appearance="small">{title}</BodyText>
          </Box>
          <Box paddingTop={4}>
            <BodyText textAlign="center" appearance="small">{body}</BodyText>
          </Box>
        </Stack>
        <Inline justifyContent="center">
          <Box paddingTop={4} paddingBottom={10}>
            <Button
              size="small"
              style={{
                borderRadius: 4,
                textTransform: 'capitalize',
              }}
              {...ctaProps}
            >
              {cta}
            </Button>
          </Box>
        </Inline>
      </Box>
    </Box>
  );
};
